var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSituationPolicy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D5DD",
  d: "M20.689 7.373H2.9a.9.9 0 0 0-.9.9v1.485a.9.9 0 0 0 .9.9h17.789a.9.9 0 0 0 .9-.9V8.273a.9.9 0 0 0-.9-.9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A2A7B3",
  d: "M19.93 10.656H3.658v7.674h16.274v-7.674Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D5DD",
  d: "M20.689 18.332H2.9a.9.9 0 0 0-.9.9v1.486a.9.9 0 0 0 .9.9h17.789a.9.9 0 0 0 .9-.9v-1.486a.9.9 0 0 0-.9-.9M12.35.3H11v4.5h1.35z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#34A59E",
  d: "M14.6.3H11v2.25h3.6a.9.9 0 0 0 .9-.9V1.2a.9.9 0 0 0-.9-.9"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M10.168 18.331v-4.718a1.678 1.678 0 0 0-3.355 0v4.718zm6.608 0v-4.718a1.678 1.678 0 0 0-3.355 0v4.718z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#56CEC2",
  d: "M11.608 3.13c-2.91 0-5.418 1.74-6.56 4.244h13.12c-1.143-2.505-3.65-4.244-6.56-4.244"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#A4D6AB",
  d: "M22.047 16h-8.095a.95.95 0 0 0-.953.952v4.279h10v-4.28a.95.95 0 0 0-.952-.952Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#7CB683",
  d: "M23 21.231H13v1.912h10V21.23Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFBE5",
  d: "M19.003 16h-2.01v7.142h2.01v-7.143Z"
})));
export default SvgSituationPolicy;